/**
* MMap object
**/
import { Loader } from '@googlemaps/js-api-loader'
import { trace } from "rytm-helpers";

let mapsApi

class MMap {

  // ## Constructor ###
  constructor( el, options ) {
    trace("new map object", el, options);
    this.el = el
    this.id = options.id;
    this.markersArr = [];
    this.infoWindows = [];
    this.startPointFromPlacemarkSet = false
    this.markersLimit = 4;
    this.clusterGridSize = 40;
    this.dataRecordSelector = '.gmplacemark-mapdata';
    this.initialZoom = options.zoom ? options.zoom : 17
    this.initializeMap();
  }
  /**
   * ### FILTER RELATED ###
   */
  filter(ids) {
    let filteredMarkers = [];
    this.markersArr.forEach((marker) => {
      const taxonsStr = marker.el.dataset.taxons
      const myIds = taxonsStr ? taxonsStr.split(",") : []
      const found = ids.some(r=> myIds.includes(r))
      if (found) {
        marker.setVisible(true)
        filteredMarkers.push(marker)
      } else {
        marker.setVisible(false)
      }
    })
  }
  resetFilters() {
    this.markersArr.forEach((marker) => {
      marker.setVisible(true)
    })
  }


  getPlacemarkIcon(name = null) {
    const fileName = name ? name : "placemark"
    return '/local/images/' + fileName + '.png';
  }
  getMapOptions() {
    return {
      zoom: this.initialZoom,
      scrollwheel: false,
      center: this.startPoint,
      disableDefaultUI: true,
      zoomControl: true,
      gestureHandling: "cooperative",
      styles: this.getMapStyles() // scroll down ;)
    };
  }

  // init map object
  initializeMap() {
    // loader
    const apiKey = this?.el?.dataset?.apiKey
    if (!apiKey) {
      console.error("No API key for map", this.el)
    }
    const loader = new Loader({
      apiKey,
      version: "weekly",
      libraries: ["places"]
    });
    loader.load().then(( google ) => {
      mapsApi = google.maps;
      this.bounds = new mapsApi.LatLngBounds();
      this.startPoint = new mapsApi.LatLng(52.229676, 21.012229);
      this.geocoder = new mapsApi.Geocoder();
      this.map = new mapsApi.Map( this.el, this.getMapOptions() );
      this.initPlacemarks();
      this.fitBounds();
    }).catch(e => {
    });

  }
  // init placemarks from $mapData
  initPlacemarks() {
    const dataSelector = this.el.dataset.mapData
    const dataWrapper = dataSelector ? document.querySelector(dataSelector) : null
    const list = dataWrapper ? [...dataWrapper.querySelectorAll(this.dataRecordSelector)] : []
    // trace(dataSelector, list)
    list.forEach(this.initPlacemark.bind(this))
  }

  // init Placemark from DOM object
  initPlacemark(el, index) {
    let lat = parseFloat(el.dataset.lat);
    let lng = parseFloat(el.dataset.lng);
    
    if (!lat || !lng) {
      return false;
    }
    // console.log("lat", lat, "lng", lng);
    let latlng = new mapsApi.LatLng(lat, lng);
    let marker = new mapsApi.Marker({
      position: latlng,
      map: this.map,
      icon: this.getPlacemarkIcon(el.dataset.placemark),
    });
    marker.el = el
    // hover?
    if (el.dataset.placemarkHover) {
      marker.addListener('mouseover', ()=>{
        marker.setIcon(this.getPlacemarkIcon(el.dataset.placemarkHover))
      });
      marker.addListener('mouseout', ()=>{
        marker.setIcon(this.getPlacemarkIcon(el.dataset.placemark))
      });
    }
    // set center to first placemark?
    if (!this.startPointFromPlacemarkSet) {
      this.map.setCenter(latlng)
      this.startPointFromPlacemarkSet = true
    }

    const markerId = el.dataset.id
    const mapURL = el.dataset.url
    const linkLabel = el.dataset.linkLabel
    let infoHtml = el.innerHTML
    if (mapURL && linkLabel) {
      infoHtml += '<a href="' + mapURL + '" target="_blank" class="venue-map-link">' + linkLabel + '</a>'
    }
    let infoWindow = new google.maps.InfoWindow({
      content: infoHtml
    })
    // // add event listeners
    marker.addListener('click', ()=>{
      this.closeInfoWindows()
      infoWindow.open(this.map, marker)
    });

    infoWindow.markerId = markerId
    infoWindow.marker = marker
    this.infoWindows.push(infoWindow)

    this.bounds.extend(latlng);
    this.markersArr.push(marker);

  }

  openInfoWindowById(id, zoom = null) {
    const infoWindow = this.getInfoWindowById(id)
    if (infoWindow) {
      this.closeInfoWindows([id])
      if (infoWindow.marker) {
        infoWindow.open(this.map, infoWindow.marker)
        if (zoom) {
          this.zoomToMarker(infoWindow.marker, zoom)
        }
      }
    }
  }
  zoomToMarker(marker, zoom) {
    this.map.setZoom(zoom)
    this.map.panTo(marker.position)
  }

  closeInfoWindows(exceptions = []) {
    this.infoWindows.forEach((iw, index) => {
      if (exceptions.indexOf(iw.markerId) < 0) {
        iw.close()
      }
    })
  }
  getInfoWindowById(id) {
    let result = null
    this.infoWindows.forEach((iw, index) => {
      if (iw.markerId == id) {
        result = iw
      }
    })
    return result
  }
  // fit Bounds
  fitBounds() {
    if (this.markersArr.length < 1) {
      // console.log("fir bounds makes no sense");
      return false;
    } else if (this.markersArr.length == 1) {
      // only one marker - center on it
      let latlng = this.markersArr[0].getPosition();
      this.map.setCenter(latlng);
    } else {
      this.map.fitBounds( this.bounds );
    }
  }


  // ### Map Styles ###
  getMapStyles() {
    return [
      {
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#f5f5f5"
          }
        ]
      },
      {
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#616161"
          }
        ]
      },
      {
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#f5f5f5"
          }
        ]
      },
      {
        "featureType": "administrative.country",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#929292"
          }
        ]
      },
      {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#bdbdbd"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#eeeeee"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#e5e5e5"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#ffffff"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#dadada"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#616161"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      },
      {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#e5e5e5"
          }
        ]
      },
      {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#eeeeee"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#c9c9c9"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      }
    ];
  }

}

export default MMap;

